<template>
  <div class="route-view has-top dark">
    <div class="card">
      <div class="card-content">
        <div class="card-head">
          <div class="title">
            {{ profile.name }}
          </div>
          <div>
            <!-- <span
              class="edit icon is-small is-left m-r-10"
              @click="modalEditProfile"
            >
              <i class="fa fa-pencil-alt"></i>
            </span> -->
            <span
              class="edit icon is-small is-left"
              @click="modalChangePassword"
            >
              <i class="fa fa-lock"></i>
            </span>
          </div>
        </div>
        <div class="detail">{{ $t('profile.id') }} : {{ profile._id }}</div>
        <div class="detail">
          {{ $t('profile.createdAt') }} :
          {{ profile.createdAt | datetimeFormat }}
        </div>
      </div>
    </div>

    <div class="section-subtitle">
      <span>{{ $t('profile.contact') }}</span>
    </div>
    <div class="field">
      <label for="" class="label">Username</label>
      <div class="control has-icons-left">
        <input
          type="text"
          placeholder="e.g. 0812345678"
          class="input text-center"
          :value="profile.username"
          readonly
        />
        <span class="icon is-small is-left">
          <i class="fa fa-user"></i>
        </span>
      </div>
    </div>

    <div class="section-subtitle">
      <span>{{ $t('profile.bankDataTitle') }}</span>
    </div>
    <div class="field">
      <label for="" class="label">{{ $t('profile.bankAccLabel') }}</label>
      <div class="control has-icons-left">
        <input
          type="text"
          placeholder="e.g. xxx xxx"
          class="input text-center"
          :value="bankAccount.bankAccountName"
          readonly
        />
        <span class="icon is-small is-left">
          <i class="fas fa-user-tie"></i>
        </span>
      </div>
    </div>
    <div class="field m-t-20">
      <label for="" class="label">{{ $t('profile.bankLabel') }}</label>
      <div class="control has-icons-left">
        <input
          v-model="bankAccount.bank.nameTH"
          type="text"
          placeholder="e.g. KBANK"
          class="input text-center"
          readonly
        />
        <span class="icon is-small is-left">
          <i class="fas fa-university"></i>
        </span>
      </div>
    </div>
    <div class="field m-t-30">
      <label for="" class="label">{{ $t('profile.accNoLabel') }}</label>
      <div class="control has-icons-left">
        <input
          type="text"
          placeholder="e.g. 0123456789"
          class="input text-center"
          :value="bankAccount.bankAccountNo | bankAccountFormat"
          readonly
        />
        <span class="icon is-small is-left">
          <i class="fas fa-money-check"></i>
        </span>
      </div>
    </div>

    <!-- <ModalEditProfile
      :is-active="modalEditProfileActive"
      :profile="profile"
      :bank-account="bankAccount"
      @closeModal="modalEditProfile"
    /> -->

    <modalChangePassword
      :is-active="modalChangePasswordActive"
      :profile="profile"
      @closeModal="modalChangePassword"
    />
  </div>
</template>

<script>
import apiAccount from '@/api/account'

// import ModalEditProfile from '@/views/user/components/modals/EditProfile'
import ModalChangePassword from '@/views/user/components/modals/ChangePassword'

export default {
  name: 'UserProfile',
  components: {
    // ModalEditProfile,
    ModalChangePassword
  },
  props: {
    page: String
  },
  data() {
    return {
      profile: {},
      bankAccount: { bank: {} },
      modalEditProfileActive: false,
      modalChangePasswordActive: false
    }
  },
  created() {
    this.$emit('childinit', this.page)
  },
  mounted() {
    this.getProfile()
  },
  methods: {
    async getProfile() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiAccount.getProfile()
          this.profile = data.profile
          this.bankAccount = data.bankAccount

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    modalEditProfile() {
      this.modalEditProfileActive = !this.modalEditProfileActive
      this.disabledBodyScroll(this.modalEditProfileActive)
    },
    modalChangePassword() {
      this.modalChangePasswordActive = !this.modalChangePasswordActive
      this.disabledBodyScroll(this.modalChangePasswordActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: $wallet-card-background;
  color: $wallet-card-text-color;
  border-radius: 10px;

  .card-head {
    display: flex;
    justify-content: space-between;

    .title {
      color: $wallet-card-text-color;
    }

    .edit {
      &:hover {
        cursor: pointer;
      }
      i {
        font-size: 20px;
        color: $wallet-card-text-color;
      }
    }
  }
  .detail {
    font-size: 14px;
  }
}
</style>
